export default __webpack_public_path__ + "static/media/01_SchererGruppe-DTM-Documentary-EschweilerPhotography_M1A3490.50d1b76f.jpg";